namespace GeniuzPOS.Product {
    export interface CsSubCategory1Row {
        Id?: number;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsSubCategory1Row {
        export const idProperty = 'SubCat1Code';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsSubCategory1';
        export const lookupKey = 'Product.CsSubCategory1';

        export function getLookup(): Q.Lookup<CsSubCategory1Row> {
            return Q.getLookup<CsSubCategory1Row>('Product.CsSubCategory1');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-2:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-2:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-2:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-2:Modify';

        export declare const enum Fields {
            Id = "Id",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
